import { StorageReference } from '@angular/fire/storage';
import { FileExtra } from '@ih/app/client/shared/interfaces';

export class ExtractZipAction {
  public static readonly type = '[Project/Storage/List] ExtractZipAction';
  constructor(public readonly file: StorageReference & FileExtra) {}
}
